var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDisabledView = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0869 6.56841C14.86 7.38179 14.86 8.61756 14.0869 9.43094C12.783 10.8028 10.5437 12.6663 8.00004 12.6663C5.45636 12.6663 3.21704 10.8028 1.91318 9.43094C1.14011 8.61756 1.14011 7.38179 1.91318 6.56841C3.21704 5.19656 5.45636 3.33301 8.00004 3.33301C10.5437 3.33301 12.783 5.19656 14.0869 6.56841Z",
    stroke: "#CACACA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 2,
    stroke: "#CACACA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDisabledView);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_disabled_view.d8d40d399498ae1308be13a979c5ae75.svg";